const AdCard = ({ rank, title, subtitle, ctaText, image, bgimage }) => {
  return (
    <div
      className="w-[270px] h-[480px] flex flex-col justify-between items-center bg-cover bg-center bg-no-repeat rounded-xl shadow-lg"
      style={{
        backgroundImage: `url(${bgimage})`,
      }}
    >
      <div className="w-full flex flex-col items-start p-4">
        <div className="inline-block bg-white px-3 py-1 rounded-full shadow">
          <span className="text-black text-xs font-bold">{rank}</span>
        </div>
        <div className="text-white text-xl font-extrabold leading-tight mb-4">
          {title}
        </div>
        <div className="text-white text-l mb-6">{subtitle}</div>
        <button className="bg-pink-500 text-white text-sm px-4 py-2 rounded-full font-semibold shadow hover:bg-pink-600 transition">
          {ctaText}
        </button>
      </div>
      {image && (
        <div className="w-full mt-12">
          <img src={image} alt="ad" className="w-full rounded-lg" />
        </div>
      )}
    </div>
  );
};

export default AdCard;
